



































import { Component, Mixins } from "vue-property-decorator";

// Providers
import WebhookTriggersInjectorMixin from "@/mixins/webhookTriggersInjectorMixin";

@Component({
  components: {
    "webhook-trigger-row-item": () =>
      import(
        "@/components/app/admin/settings/webhooks/webhookTriggerRowItem.vue"
      )
  }
})
export default class WebhookTriggersListing extends Mixins(
  WebhookTriggersInjectorMixin
) {
  // Computed

  public get skeletonSize() {
    return this.$webhookTriggersData.webhookTriggers.length ||
      this.$store.getters["ui/isMobile"]
      ? 2
      : 3;
  }

  public get showEmptyState() {
    return (
      !this.$webhookTriggersData.isLoading && !this.$webhookTriggersData.total
    );
  }

  public get showSkeletons() {
    return (
      this.$webhookTriggersData.isLoading || !this.$webhookTriggersData.total
    );
  }
}
